import * as React from 'react';
import './Tabs.scss';

export interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTabId: string | null;
  onTabChange: (tabId: string) => void;
}

export const Tabs = ({
  tabs,
  activeTabId,
  onTabChange,
}: TabsProps): JSX.Element => {
  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLButtonElement>,
    index: number
  ) => {
    if (event.key === 'ArrowRight') {
      const next = (index + 1) % tabs.length;
      onTabChange(tabs[next].id);
    }

    if (event.key === 'ArrowLeft') {
      const prev = (index - 1 + tabs.length) % tabs.length;
      onTabChange(tabs[prev].id);
    }
  };

  return (
    <div role='tablist' aria-orientation='horizontal' className='tabs'>
      {tabs.map((tab, index) => {
        const isActive = tab.id === activeTabId;
        return (
          <button
            key={tab.id}
            role='tab'
            aria-selected={isActive}
            tabIndex={isActive ? 0 : -1}
            className={`tab ${isActive ? 'tab--active' : ''}`}
            onClick={() => onTabChange(tab.id)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            type='button'
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};
